import api from "./api.js";

export default class FirstVisitApi {
  // ---------- 첫 방문이라면? ---------- //
  static async create(data) {
    return await api.post(`api/first-visit`, data);
  }

  static async getList(params) {
    return await api.get(`api/first-visit`, params);
  }

  static async delete(params) {
    return await api.del(`api/first-visit`, params);
  }

  static async getById(id) {
    return await api.get(`api/first-visit/${id}`);
  }

  static async update(id, data) {
    return await api.patch(`api/first-visit/${id}`, data);
  }
}
